import { getLangSite, validateForChineseLanguage } from "../ultils";
import { IUtag } from "../models/IUtag";
import { IProductDetailById } from "../models/ProductDetailById";

export function callFunctionDkView(obj:IUtag) {
    delete obj.number_results_returned_from_search;
    delete obj.additional_data;
    const pageWindow: any = window as { [key: string]: any }['window'];
    if (pageWindow && pageWindow.utag) {
      try{
        pageWindow.utag.dkView(obj);
      }catch(err){
        console.log(err);
      }
    }
  }

//#region Helpers
export function callGTMAnalytics(utag_Data: IUtag, event?:string | null, additionalData?: any) {
  const utagData : IUtag = validateEvent(utag_Data, event);

  let eventItem: Object = {}

  if(utagData?.ref_page_event){
    eventItem = {
      ...eventItem,
      ...mappingEventFromTeliumToGTM(utagData, additionalData)
    };
  }

  const dataItems = collectEventBeforeFiring(utagData, eventItem)

  if (dataItems?.length) {
    callGTMEventPush(dataItems)
  }
}

//#region GTM Functions
function callGTMEventPush(eventItems: Object[]) {
  const pageWindow: any = window as { [key: string]: any }['window'];
  if (typeof pageWindow?.dataLayer?.push === 'function') {
    eventItems.forEach(item => {
      if(Object.keys(item).length > 0){
        pageWindow.dataLayer.push(
          // Event type is not necessarily required when pushing updated data to dataLayer.
          item
        )
      }
    })
  }
}
//#endregion

//#region helper
function mappingEventFromTeliumToGTM(utagData : IUtag, additionalData?: any) {
  //
  switch (utagData.ref_page_event) {
    case 'Search by Url':
    case 'Search for Part': {
      let data = {
        'event': 'part_search_submit',
        'click_text': 'Search for Part',
        'part_search_results_count': utagData.part_search_results_count?.toString(),
        'part_search_term': utagData.manufacturer_part_number,
        'part_search_results_number': utagData.number_results_returned_from_search
      }

      if(utagData.part_search_filter?.split(',').length){
        const part_search_filter = {
          'part_search_filter': utagData.part_search_filter,
        }
        data = {
          ...data,
          ...part_search_filter
        }
      }
      return data
    }
    case 'Sort Table': 
    case 'Environment Page': 
    case 'Click Compare Products': 
    case 'Hide Shared Attributes': 
    case 'Return to View': 
    case 'Change Page in Search Results': 
    case 'No Results - TechForum': 
    case 'Error': 
    case 'See Example': 
    case 'Share Results': 
    case 'Feedback and Suggestions': 
    case 'Compare':
    case 'Base Parts': 
    case 'Pinouts': 
    case 'Reverse Lookup': {
      return {
        'event': 'cross_reference_click',
        'click_text': utagData.ref_page_event,
      };
    }
    case 'Result Options': {
      return {
        'event': 'product_search_filter',
        'click_text': utagData.ref_page_event,
        'part_search_filter': utagData.part_search_filter ?? '',
        'part_search_term': utagData.manufacturer_part_number,
        'part_search_results_count': utagData?.part_search_results_count?.toString() ?? '0',
        'part_search_results_number': utagData.number_results_returned_from_search,
      };
    }
    case 'Download Table': {
      return {
        'event': 'product_search_download_table',
        'click_text': utagData.ref_page_event,
        'product_index': 'Cross Reference Part Search',
        'product_category': utagData.manufacturer_part_number,
      }
    }
    case 'View Similar Parts': {
      return {
        'event': 'cross_reference_click',
        'click_text': utagData.ref_page_event,
        'event_state': utagData.event_state,
      }
    }
    case 'Filter Column': {
      return {
        'event': 'product_search_filter',
        'click_text': utagData.ref_page_event,
        'product_index': 'Cross Reference Part Search',
        'product_category': utagData.manufacturer_part_number,
        'product_filter_options': additionalData
      }
    }
    case 'Display Asset':{
      return {
        'event': 'datasheet_click',
        'click_text': utagData.ref_page_event,
        'asset_type': 'Datasheet'
      }
    }
      case 'Link to Part':
      case 'Add To List': {
      let items = [];
      let item_list_detail = {
        item_list_name: utagData.page_type + "-" + utagData.page_sub_type,
        item_list_id: utagData.page_id
      }
      items = additionalData.map((item:IProductDetailById)=>{
        let product = item.productVariations.find(product => {
          return product.masterProductId === item.productId
        })

        let item_category_temp = {...item.category};
        let item_categories = {}
        let i = 1;
        while (item_category_temp.childCategories.length > 0){
          let object = {[`item_category${i==1?"":i}`]: item_category_temp.categoryId}
          item_categories = {...item_categories,
            ...object
          }
                    i++;
          item_category_temp = {...item_category_temp.childCategories[0]}
        }
        
        let finalResult = {
          item_id: product?.masterProductId,
          item_brand: product?.supplier.id,
          item_brand_name: product?.supplier.name,
          item_sku: product?.digiKeyProductNumber,
          item_part_type: item?.productClass,
          item_stock_status: item?.isNonStock? 0 : 1,        
        }

        if(Object.keys(item_categories).length > 0){        
          finalResult = {
            ...finalResult,
            ...item_categories
          }
          return {...finalResult,
          ...item_list_detail}
        }

        return finalResult
      })       
      
      return {
        'event': utagData.ref_page_event === 'Link to Part' ? 'select_item' : 'add_to_wishlist',
        'click_text': utagData.ref_page_event,
        'ecommerce':{
          'currency': validateForChineseLanguage(getLangSite('en')) ? "CNY" : "USD",
          'local_currency': getCurrencyCodeIso() ?? "USD",
          'items':[...items]
        }
      }
    }
    case 'View item list':{
      let item_list_detail = {
        item_list_name: utagData.page_type + "-" + utagData.page_sub_type,
        item_list_id: utagData.page_id
      }
      let view_list_item_event = {
        'event': 'view_item_list',
        'ecommerce':{
          'currency': validateForChineseLanguage(getLangSite('en')) ? "CNY" : "USD",
          'local_currency': getCurrencyCodeIso() ?? "USD",
          'items':[item_list_detail]
        }
      }
      return view_list_item_event
    }
    default: {
      return null;
    }
  }
}

function getCurrencyCodeIso(){
  const cookieValue = document.cookie
  .split("; ")
  .find((row) => row.startsWith("cur="))
  ?.split("=")[1];
  return cookieValue;
}

function validateEvent(utagData:IUtag, event?:string | null){
  let utag ={
    ...utagData
  }

  if(event){
    const ref_page_event = {
      ref_page_event:event
    };

    utag = {
      ...utag,
      ...ref_page_event
    }
  }
  
  return utag
}

function collectEventBeforeFiring(utagData: IUtag, event: any){
  switch(utagData.ref_page_event){
    //Handle for special case firing 
    case 'Optional 1': 
    case 'Search for Part':{
      let data = {
        'event': 'page_view',
        'content_group1': utagData?.page_content_group ?? '',
        'content_group2': utagData?.page_content_sub_group ?? '',
        'page_title': utagData?.page_title ?? '',
        'page_type': utagData?.page_type ?? '',
        'page_sub_type': utagData?.page_sub_type ?? '',
        'page_id': utagData?.page_id ?? '',
        'part_search_results_count': utagData?.part_search_results_count?.toString() ?? '0',
      };
        let newUtag = {...utagData, ...{ref_page_event: 'View item list'}}
        let view_list_item_event = mappingEventFromTeliumToGTM(newUtag)
        return [...[data], ...[{ ecommerce: null }], ...[view_list_item_event], ...[event]]
      return [...[data] ,...[event]];
    }
    case 'Search by Url':{
      if(utagData.number_results_returned_from_search && utagData.number_results_returned_from_search !== 0){
        let newUtag = {...utagData, ...{ref_page_event: 'View item list'}}
        let view_list_item_event = mappingEventFromTeliumToGTM(newUtag)
        return [...[{ ecommerce: null }],...[view_list_item_event], ...[event]]
      }
      return [event];
    }
    case 'Link to Part': 
    case 'Add To List':
      // Clear previous ecommerce object
      return [...[{ ecommerce: null }], ...[event]]
    default:
      return [event];
  }
}
//#endregion